import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgArrowOutlineRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0m-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-8 2H5V8h5V5l5 5-5 5z"
      fill="currentColor"
    />
  </svg>
);
